import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

// Warn instead of throwing to prevent white-screen crash on missing env vars.
// Auth features will fail gracefully if these are empty. Use console.warn (not
// error) so environments that never touch auth — the marketing pages, CI e2e —
// don't trip a "no console errors" gate on a config notice.
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Missing Supabase environment variables (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY). ' +
    'Auth features will not work.'
  )
}

export const supabase = createClient(supabaseUrl || 'https://placeholder.supabase.co', supabaseAnonKey || 'placeholder')
